import './style.css';
import { jsx as c, jsxs as i } from "react/jsx-runtime";
import u from "../StarRating/StarRating.js";
const d = "_container_1rg2f_1", m = "_anchor_1rg2f_7", N = "_rating_1rg2f_12", g = "_reviewCount_1rg2f_25", r = {
  container: d,
  anchor: m,
  rating: N,
  reviewCount: g
}, h = 3, M = 5;
function R({
  rating: n,
  decimalPrecision: t = 2,
  ariaLabel: a,
  reviewCount: o,
  reviewCountTitle: s,
  minimumRating: e = h,
  maximumRating: _ = M,
  href: l
}) {
  const f = s && o ? s(o) : "";
  return !n || n < e || n > _ ? null : /* @__PURE__ */ c("div", { className: r.container, children: /* @__PURE__ */ i(p, { href: l, className: r.anchor, children: [
    /* @__PURE__ */ c(
      u,
      {
        rating: n,
        decimalPrecision: t,
        ariaLabel: a
      }
    ),
    !!n && /* @__PURE__ */ c("span", { className: r.rating, children: n.toFixed(1) }),
    !!o && /* @__PURE__ */ i("span", { className: r.reviewCount, title: f, children: [
      "(",
      o,
      ")"
    ] })
  ] }) });
}
function p({ href: n, children: t, className: a }) {
  return n ? /* @__PURE__ */ c("a", { href: n, className: a, children: t }) : t;
}
export {
  R as default
};
//# sourceMappingURL=ProductRating.js.map
